import { getTemplate } from "../templates/email"
import { Emails } from "../config/db"

const AWS = require("aws-sdk")
const Charset = "UTF-8"

AWS.config.update({
  accessKeyId: process.env.GATSBY_AWS_ACCESS_KEY_ID,
  secretAccessKey: process.env.GATSBY_AWS_SECRET_ACCESS_KEY,
  region: process.env.GATSBY_AWS_REGION,
})

const ses = new AWS.SES()
const sender = process.env.GATSBY_AWS_SES_SENDER_EMAIL
const reportEmail = process.env.GATSBY_REPORT_EMAIL

export const isSubscribed = async email => {
  const fetchedEmail = await Emails.fetchEmail("email", email)
  if (!fetchedEmail) {
    Emails.create({ email, subscribed: true })
    return true
  }
  return fetchedEmail.subscribed
}

export const sendEmail = async (template, context, recipient) => {
  if (recipient !== reportEmail) {
    const subscribed = await isSubscribed(recipient)
    if (!subscribed) return
  }
  const { subject, body } = getTemplate(template, context, recipient)
  const params = {
    Destination: {
      BccAddresses: [],
      CcAddresses: [],
      ToAddresses: [recipient],
    },
    Message: {
      Body: {
        Html: { Charset, Data: body },
        Text: { Charset, Data: body },
      },
      Subject: { Charset, Data: subject },
    },
    Source: sender,
  }

  ses.sendEmail(params, function (err) {
    if (err) console.error(err, err.stack)
  })
}
